import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Mohammad Abdullah',
    title: "Web Developer",
    desciption:"Every great developer you know got there by solving problems they were unqualified to solve until they actually did it. ",
    image: 'https://i.ibb.co/VHXWDx1/1635858670651.png',
    resumePdf: resume
}
